 /*=========================================================================================
  File Name: state.js
  Description: Menus Actions
  ----------------------------------------------------------------------------------------
  Item Name: Menus State Module
  Author: Tan Tran
==========================================================================================*/
import queries from '../../../services/menus/queries.js'
import commands from '../../../services/menus/commands.js'
import ErrorHandling from '../../../common/exceptions/ErrorHandling.js'
import TimeFormatter from '../../../common/utils/TimeFormatter'

export default {

    async getMenusAction ( { commit, state, rootState }, payload) {

        let restaurantId = rootState.auth.auth.restaurantId;
        let token = rootState.auth.auth.token;

        try {
            await queries.getMenusByRestaurant(restaurantId, token)
                     .then(
                         res => {
                             commit('SET_MENUS_STATE', res);
                        });
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
        
       

        
    }, 

    async getItemsInRepositoryAction( { commit, state, rootState }, payload ) {

        let restaurantId = rootState.auth.auth.restaurantId;

        await queries.getItemsInRepositoryByRestaurant(restaurantId)
                        .then(
                            res => {
                                commit('SET_ITEMS_IN_REPOSITORY_STATE', res); 
                        });


    },

    async createMenuAction( { commit, state, rootState }, payload) {

        let restaurantId = rootState.auth.auth.restaurantId;

        let token = rootState.auth.auth.token;
        let menuItems = [];

        payload.menuItems.forEach(o => {
            menuItems.push(o.itemId)
        });

        let menu = {
            menuName : payload.menuName,
            description : payload.description,
            restaurantId : restaurantId,
            monday : payload.monday,
            tuesday : payload.tuesday,
            wednesday : payload.wednesday,
            thursday : payload.thursday,
            friday : payload.friday,
            saturday : payload.saturday,
            sunday : payload.sunday,
            fromTime : TimeFormatter.timeToString(payload.fromTime),
            toTime : TimeFormatter.timeToString(payload.toTime),
            menuItems : menuItems
        }

        try {
            await commands.createMenu(menu, restaurantId, token); 
            commit('ADD_MENU_STATE', menu);
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
        
    },

    async updateMenuAction( {commit, state, rootState }, payload) {

        let restaurantId = rootState.auth.auth.restaurantId;

        let token = rootState.auth.auth.token;

        let menuItems = [];

        payload.menuItems.forEach(o => {
            menuItems.push(o.itemId)
        });

        payload.fromTime = TimeFormatter.timeToString(payload.fromTime);
        payload.toTime = TimeFormatter.timeToString(payload.toTime);
        payload.menuItems = menuItems;

        try {
            await commands.updateMenu(payload.menuId, payload, token);
            commit('UPDATE_MENU_STATE', payload)
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
    } 

}